import { Component, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CompaniesService } from 'src/app/core/companies.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';

@Component({
  selector: 'app-companies-archive-dialog',
  templateUrl: './companies-archive-dialog.component.html',
  styleUrls: ['./companies-archive-dialog.component.scss'],
})
export class CompaniesArchiveDialogComponent {
  is_archive_running: boolean = false;
  company_id?: string;
  company_business_name?: string;

  company_archive_form_group: FormGroup;
  error_matcher: FormErrorStateMatcher;

  constructor(
    private dialog_ref: MatDialogRef<CompaniesArchiveDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private error_service: ErrorService,
    private companies_service: CompaniesService,
    private form_service: FormService,
  ) {
    this.company_id = data.company_id;
    this.company_business_name = data.company_business_name;
    this.company_archive_form_group = this.form_service.company_archive_form_group;
    this.error_matcher = this.form_service.matcher;
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onArchiveClick(): void {
    if (this.company_id) {
      const note = this.company_archive_form_group.get(this.form_service.note_label)?.value;
      this.archive(this.company_id, note);
    }
  }

  archive(company_id: string, note: string): void {
    this.is_archive_running = true;
    this.companies_service.archive(company_id, note).subscribe({
      next: () => {
        this.dialog_ref.close({ success: true });
        this.is_archive_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        this.dialog_ref.close({ error: processed_error });
        this.is_archive_running = false;
      },
    });
  }

  isFormValid(): boolean {
    return this.form_service.validateForm(this.company_archive_form_group);
  }
}
